import { render, staticRenderFns } from "./FiltersDrawer.vue?vue&type=template&id=63acae17&scoped=true"
import script from "./FiltersDrawer.ts?vue&type=script&lang=ts&external"
export * from "./FiltersDrawer.ts?vue&type=script&lang=ts&external"
import style0 from "./FiltersDrawer.vue?vue&type=style&index=0&id=63acae17&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63acae17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63acae17')) {
      api.createRecord('63acae17', component.options)
    } else {
      api.reload('63acae17', component.options)
    }
    module.hot.accept("./FiltersDrawer.vue?vue&type=template&id=63acae17&scoped=true", function () {
      api.rerender('63acae17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Core/components/FiltersDrawer/FiltersDrawer.vue"
export default component.exports